import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { OWNER } from "constants/index"
import { isItemViewPage } from "utils/navigatorUtils"
import { useAppSelector } from "appRedux/hooks"
import { updateWishListInfo } from "appRedux/slices/wishListSlice"
import { useLazyGetWishListQuery, wishListApi } from "appRedux/slices/wishListApiSlice"
import { useLazyGetUserWishListQuery, userProfileApi } from "appRedux/slices/userApiSlice"

export default function useWishList(listIsEmpty: boolean) {
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)
  const role = useAppSelector((state) => state.global.role)

  const cachedWishList = useAppSelector((state) => {
    if (role === OWNER && currentPageInfo?.dynamicPathParts?.listId) {
      return wishListApi.endpoints.getWishList.select(Number(currentPageInfo?.dynamicPathParts?.listId))(state)
    } else if (currentPageInfo?.dynamicPathParts?.handle && currentPageInfo?.dynamicPathParts?.listId) {
      return userProfileApi.endpoints.getUserWishList.select({
        id: Number(currentPageInfo?.dynamicPathParts?.listId),
        handle: currentPageInfo?.dynamicPathParts?.handle
      })(state)
    }
    return null
  })

  const [triggerGetWishList, loggedInUserWishListResult] = useLazyGetWishListQuery()
  const [triggerGetUserWishList, viewedUserWishListResult] = useLazyGetUserWishListQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentPageInfo?.dynamicPathParts?.handle) return
    if (!isItemViewPage(currentPageInfo?.path)) return
    if (cachedWishList?.data) {
      dispatch(updateWishListInfo(cachedWishList.data))
      return
    }
    fetchWishList()
  }, [role, currentPageInfo?.dynamicPathParts])

  function fetchWishList() {
    if (listIsEmpty) return
    if (role === OWNER && currentPageInfo?.dynamicPathParts?.listId) {
      triggerGetWishList(Number(currentPageInfo?.dynamicPathParts?.listId))
    } else if (currentPageInfo?.dynamicPathParts?.handle && currentPageInfo?.dynamicPathParts?.listId) {
      triggerGetUserWishList({ id: Number(currentPageInfo?.dynamicPathParts?.listId), handle: currentPageInfo?.dynamicPathParts?.handle })
    }
  }

  return {
    wishList: cachedWishList?.data || (role === OWNER ? loggedInUserWishListResult.data : viewedUserWishListResult.data),
    isFetching: role === OWNER ? loggedInUserWishListResult.isFetching : viewedUserWishListResult.isFetching,
    isError: role === OWNER ? loggedInUserWishListResult.isError : viewedUserWishListResult.isError
  }
}
